var React = require('react');

function LeftArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.32463 265.2L227.273 484.144C232.337 489.212 239.097 492.004 246.305 492.004C253.513 492.004 260.273 489.212 265.337 484.144L281.461 468.024C291.953 457.52 291.953 440.448 281.461 429.96L97.6046 246.104L281.665 62.044C286.729 56.976 289.525 50.22 289.525 43.016C289.525 35.804 286.729 29.048 281.665 23.976L265.541 7.85998C260.473 2.79199 253.717 0 246.509 0C239.301 0 232.541 2.79199 227.477 7.85998L8.32463 227.004C3.24863 232.088 0.460631 238.876 0.476631 246.092C0.460631 253.336 3.24863 260.12 8.32463 265.2Z","fill":"white"}));
}

LeftArrow.defaultProps = {"width":"290","height":"493","viewBox":"0 0 290 493","fill":"none"};

module.exports = LeftArrow;

LeftArrow.default = LeftArrow;
